import React, { useContext } from 'react'
import { UneeqContext, useUneeqError, ErrorLevel } from 'uneeq-react-core'
import Error from './Error'
import FatalError from './FatalError'
import Warning from './Warning'

const Errors = () => {
  const error = useUneeqError()
  const { dispatch } = useContext(UneeqContext)
  const clearError = () => dispatch({ type: 'clearError' })

  switch (error?.level) {
    case ErrorLevel.WARNING:
      return <Warning message={error.message} />
    case ErrorLevel.ERROR:
      return <Error message={error.message} />
    case ErrorLevel.FATAL:
      return <FatalError errorMessage={error.message} clearError={clearError} />
    default:
      return null
  }
}

export default Errors
